import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import addCircleIcon from "../../assets/svg/add_circle.svg";
import Paper from "@material-ui/core/Paper";
import deleteIcon from "../../assets/images/delete.png";
import editIcon from "../../assets/images/edit.png";
import { Button, Form } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import { CiSearch } from 'react-icons/ci';
import 'react-modern-drawer/dist/index.css'
import Loader from '../../components/loader/loader';
import { Box } from '@material-ui/core';
import { checkUserPermissions } from '../../helpers/permission';
import { IoIosAdd } from 'react-icons/io';
import { deleteRole, getAllRoles } from '../../api/context/roles';
import CustomisedModal from '../../components/Modal/CustomisedModal';
import { FaRegSquarePlus } from 'react-icons/fa6';
import { Tooltip } from "@mui/material";

const queueDatatableCustomStyles = {
    headCells: {
        style: {
            fontWeight: '600',
            fontSize: '14px'

        },
    },
    cells: {
        style: {
            fontSize: '12px',
            fontWeight: '500',
            padding: '12px',
        },
    },

};
export const Roles = () => {

    const navigate = useNavigate();

    const [data, setData] = useState([]);
    const [update, setUpdate] = useState(false)
    const [loading, setLoading] = useState(false);
    const [totalRows, setTotalRows] = useState(0);
    const [limit, setLimit] = useState(10);
    const [page, setPage] = useState(1);
    const [search, setSearch] = useState('');
    const [initial, setInitial] = useState(false)

    const [modal, setModal] = useState(false);
    const [deletingId, setDeletingId] = useState("");

    const toggleModal = () => {
        setModal(!modal);
    };

    const columns = [
        {
            name: "S. No.",
            selector: (row, index) => ((page * limit) - limit) + (index + 1),
            width: '90px'
        },
        {
            name: "Name",
            selector: row => row.name,
            cell: (row) => <Tooltip title={row?.name} disableInteractive placement='top'><div className='text-truncate'>{row?.name}</div></Tooltip>,
            minWidth: '200px'
        },


        {
            name: "ACTION",
            cell: (row) =>
                <div>

                    <div className='d-flex flex-row gap-3' role='button'>
                        <Tooltip title="Edit" disableInteractive placement="top">
                            <div className="edit_icon_bg" onClick={() => navigate('/edit-role/' + row.id)}>
                                <img
                                    src={editIcon}
                                    alt="Edit"
                                    className="edit_icon"
                                />
                            </div>
                        </Tooltip>
                        <Tooltip title="Delete" disableInteractive placement="top">
                            <div className="delete_icon_bg" onClick={() => handleConfirm(row?.id)}>
                                <img
                                    src={deleteIcon}
                                    alt="Delete"
                                    className="delete_icon"
                                />
                            </div>
                        </Tooltip>
                    </div>

                </div>,
            width: '200px'
        },
    ]


    const handleConfirm = (deletingId) => {
        setModal(!modal);
        setDeletingId(deletingId);
    }

    const deleteRoles = (id) => {
        deleteRole(id)((response) => {
            if (response?.data?.statusCode == 200) {
                setUpdate(!update);
                setModal(!modal);
            } else {

            }
        });

    }

    useEffect(() => {
        setLoading(true)
        getRolesData()
    }, [update])

    useEffect(() => {
        let timeout = setTimeout(() => {
            if (initial)
                setUpdate(!update)
            else
                setInitial(true)
        }, 500);

        return () => {
            clearTimeout(timeout)
        }
    }, [search])

    const getRolesData = async () => {
        getAllRoles({ page: page, pageSize: limit, search: search })((response) => {
            if (response?.data?.statusCode == 200) {
                setData(response?.data?.data?.roles);
                setTotalRows(response?.data?.data?.totalPages)
                setLoading(false)
            } else {
                setData([])
                setLoading(false)
            }
        })
    }


    const handlePerRowsChange = (newPerPage, page) => {
        setLimit(newPerPage)
        setPage(1)
        setUpdate(!update)
    }
    const handlePageChange = (page) => {
        setPage(page)
    }

    return (
        <>
            <div className="row">
                <div className="col-12">
                    <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                        <h4 className="mb-sm-0">Roles</h4>
                    </div>
                </div>
            </div>
            <div className="create-button-section">


                {/* <div className='d-flex gap-1'>
                        <div className='position-relative'>
                            <Form.Group controlId="exampleForm.ControlInput1">
                                <Form.Control
                                    type="text"
                                    placeholder="Search"
                                    className='filter-search'
                                    onChange={(e) => setSearch(e.target.value)}
                                />
                                <CiSearch className='custom-search-icon' />
                            </Form.Group>
                        </div>

                    </div> */}

                <div className='request_wrapper'>
                    <Button className='request_btn' onClick={() => navigate('/create-role')}><FaRegSquarePlus className='icon' />Add New</Button>
                </div>
                {/* <button class="btn btn-custom-primary btn-label" onClick={() => navigate('/create-role')}>
                        <div class="d-flex">
                            <div class="flex-shrink-0">
                                <IoIosAdd className="ri-user-smile-line label-icon align-middle fs-14 me-2" style={{ height: '100%' }} />
                            </div>
                            <div class="flex-grow-1">
                                Add new
                            </div>
                        </div>
                    </button> */}

            </div>



            <Box className="products-and-options" sx={{ mt: 1 }}>
                <Paper square>
                    <div>
                        <DataTable
                            columns={columns}
                            data={data}
                            progressPending={loading}
                            progressComponent={<div style={{ height: '60vh' }}><Loader /></div>}
                            pagination
                            paginationServer
                            paginationTotalRows={totalRows}
                            paginationPerPage={limit}
                            onChangeRowsPerPage={handlePerRowsChange}
                            onChangePage={handlePageChange}
                            customStyles={queueDatatableCustomStyles}
                        />
                    </div>
                </Paper>
            </Box>

            <CustomisedModal
                isOpen={modal}
                customClass={"policy_modal"}
                toggle={toggleModal}
            >
                <h5>
                    Are you sure you want to remove this role?
                </h5>
                <div className="policy_Agree">
                    <Button
                        onClick={() => {
                            setModal(!modal);
                        }}
                        size="lg"
                        className='btn_cancel'
                    >
                        Cancel
                    </Button>
                    <Button
                        size="lg"
                        className='btn'
                        onClick={() => deleteRoles(deletingId)}
                    >
                        Delete
                    </Button>
                </div>
            </CustomisedModal>

        </>
    )
}
